import isTestCafeEnabled from '@/helpers/isTestCafeEnabled'
import type { ApiEndpoints } from '@/types'

type Params = Record<string, any>

class Endpoints {
  private apiPrefix: string

  constructor() {
    this.apiPrefix = isTestCafeEnabled()
      ? import.meta.env.VITE_APP_API_BASE_TESTCAFE_URL
      : import.meta.env.VITE_APP_API_URL
    this.apiPrefix += 'v1/'
  }

  get(endpointLabel: ApiEndpoints, params?: Params): string {
    let url = endpointLabel as string

    // refactor: czy Axios nie ma obsługi wbudowanej w geta,
    // że można przekazywać parametry jako obiekt i sobie poradzi z tym. To mogłoby uprościć ten kod
    if (typeof params === 'object') {
      Object.keys(params).forEach((param) => {
        url = url.replace(`:${param}`, params[param])
      })
    } else if (url.indexOf('/:') > 0) {
      url = url.substring(0, url.indexOf('/:'))
    }

    return this.apiPrefix.concat(url)
  }
}

export default new Endpoints()
